/**
 * @desc 创建报表任务
 */
const URL = "/rantion-report";
import http, { updateResponse } from "@/http";
export function request(body: defs.report.ReportTaskRecordRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/reportTaskRecord/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
